import { Skeleton, Stack, useTheme } from "@mui/material";
import type { FC } from "react";

export const CalculatorRateBarSkeleton: FC = () => {
	const theme = useTheme();

	return (
		<Stack direction="row" alignItems="center" gap={theme.spacingTokens.sm}>
			<Skeleton variant="text" width={56} height={16} animation="wave" />
			<Skeleton
				variant="rounded"
				height={8}
				animation="wave"
				sx={{ flex: 1, borderRadius: theme.radii.full }}
			/>
			<Skeleton variant="text" width={52} height={16} animation="wave" />
		</Stack>
	);
};
